import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

const RouteComponent = () => {
  const location = useRouterState({ select: (s) => s.location });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <Outlet />;
};

export const Route = createRootRoute({
  component: RouteComponent,
});
